// materials-research-init.js — wires the Materials Validation tab.
// Mirrors plasma-research-init.js. The validation table loads on first tab
// open and auto-reruns on subsequent opens.

import {
  initMaterialsResearch,
  renderMaterialsValidationTable,
  runPhonons, runElasticTensor, runTc, runDos
} from './materials-research.js';

async function bootstrap() {
  await initMaterialsResearch();

  const validationTab = document.querySelector('.mattab[data-mat="validation"]');
  if (validationTab) {
    let loaded = false;
    validationTab.addEventListener('click', async () => {
      if (!loaded) {
        await renderMaterialsValidationTable();
        loaded = true;
      } else {
        window.gdbsRerunAllMaterialsValidation?.();
      }
    });
  }

  // Run All button — same as auto-rerun.
  const runBtn = document.getElementById('btn-mat-validation-run');
  if (runBtn) {
    runBtn.addEventListener('click', async () => {
      const tbody = document.getElementById('tbody-mat-validation');
      if (tbody && !tbody.children.length) {
        await renderMaterialsValidationTable();
      } else {
        window.gdbsRerunAllMaterialsValidation?.();
      }
    });
  }
  // New research-grade engines.
  document.getElementById('btn-phonons-run')?.addEventListener('click', runPhonons);
  document.getElementById('btn-elastic-tensor-run')?.addEventListener('click', runElasticTensor);
  document.getElementById('btn-tc-run')?.addEventListener('click', runTc);
  document.getElementById('btn-dos-run')?.addEventListener('click', runDos);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
